import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import SyncIcon from '@mui/icons-material/Sync';
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { colorTokens, typographyTokens } from '../../app/designTokens';
import { RegisterSectionCard } from './RegisterSectionCard';

const { semantic } = colorTokens;

function StageIcon({ state }) {
  if (state === 'completed') {
    return <CheckCircleOutlineIcon sx={{ color: semantic.success }} fontSize="small" />;
  }
  if (state === 'failed') {
    return <ErrorOutlineIcon sx={{ color: semantic.error }} fontSize="small" />;
  }
  if (state === 'active') {
    return (
      <SyncIcon
        data-testid="launch-stage-active-icon"
        sx={{
          color: semantic.status.brand.border,
          animation: 'maf-spin 1.2s linear infinite',
          '@keyframes maf-spin': {
            from: { transform: 'rotate(0deg)' },
            to: { transform: 'rotate(360deg)' },
          },
        }}
        fontSize="small"
      />
    );
  }
  return <RadioButtonUncheckedIcon sx={{ color: semantic.text.muted }} fontSize="small" />;
}

/** Step 5 — provisioning steps derived from backend launch status only. */
export function ProvisioningStepList({ stages, testId = 'register-launch-provisioning-steps' }) {
  const { t } = useTranslation(['onboarding']);
  const label = t('onboarding:register.launch_stages_label');

  return (
    <RegisterSectionCard title={label} testId={testId}>
      <List dense disablePadding aria-label={label} data-testid="register-launch-stages">
        {stages.map((stage) => (
          <ListItem
            key={stage.id}
            data-testid={`register-launch-stage-${stage.id}`}
            data-state={stage.state}
            sx={{
              px: 1,
              py: 0.75,
              borderRadius: 1,
              bgcolor: stage.state === 'active' ? semantic.bg.surfaceSelected : 'transparent',
              mb: 0.5,
            }}
          >
            <ListItemIcon sx={{ minWidth: 36 }}>
              <StageIcon state={stage.state} />
            </ListItemIcon>
            <ListItemText
              primary={t(`onboarding:register.launch_stages.${stage.id}`)}
              secondary={t(`onboarding:register.launch_stage_state.${stage.state}`)}
              primaryTypographyProps={{
                sx: {
                  fontFamily: typographyTokens.fontFamily,
                  fontSize: 14,
                  fontWeight: stage.state === 'active'
                    ? typographyTokens.fontWeightSemibold
                    : 400,
                  color: semantic.text.primary,
                },
              }}
              secondaryTypographyProps={{
                sx: { fontSize: 12, color: semantic.text.muted },
              }}
            />
          </ListItem>
        ))}
      </List>
    </RegisterSectionCard>
  );
}

export default ProvisioningStepList;
